<template>
  <div
    class="code-input"
    :class="{
      'code-input--complete': isComplete,
      'code-input--error': error,
      'code-input--disabled': disabled,
      'code-input--loading': loading,
    }"
  >
    <input
      v-for="(digit, index) in digits"
      :key="index"
      ref="inputs"
      type="text"
      inputmode="numeric"
      autocomplete="one-time-code"
      :maxlength="length"
      class="code-input__digit"
      :value="digit"
      :disabled="disabled"
      :style="{ '--index': index }"
      @input="handleInput($event, index)"
      @change="handleInput($event, index)"
      @keydown="handleKeydown($event, index)"
      @paste="handlePaste"
      @focus="handleFocus"
    />
  </div>
</template>

<script src="./code-input.js"></script>
<style src="./code-input.scss" lang="scss"></style>
